export class ArgParser {
  /**
   * Parses the arguments passed as an unsigned integer.
   * @param value A value to be parsed as a
   * @param fallback A fallback value to be returned if the parsing fails
   * @returns Parsed value, fallback, or null
   */
  static parseUInt<Default = null>(
    value: string | number,
    fallback: Default = null
  ): number | Default {
    try {
      const num = Number(value)
      return Number.isInteger(num) && num > 0 ? num : fallback
    } catch (e) {
      return fallback
    }
  }

  static parseBool<Default = null>(
    value: string | boolean,
    fallback: Default = null
  ): boolean | Default {
    try {
      if (typeof value === 'boolean') return value
      return ['true', 'false'].includes(value) ? value === 'true' : fallback
    } catch (e) {
      return fallback
    }
  }
}
